<template>
  <div class="banner-container primary-bg" height="125">
    <v-row class="banner-content" align="center">
      <v-col cols="12" md="1" class="d-flex justify-center align-center">
        <v-avatar v-if="avatar" slot="icon">
          <img alt="Avatar" v-bind:src="avatar" />
        </v-avatar>
        <v-avatar v-else slot="icon" color="grey lighten-2">
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>
      </v-col>
      <v-col cols="12" md="11" class="d-flex align-center justify-center justify-md-start">
        <v-list-item two-line class="px-0">
          <v-list-item-content class="text-center text-md-left">
            <v-list-item-title class="body-heading-small mb-3 white--text">
              {{ name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-icon size="20" color="secondary" class="mr-1">fas fa-gem</v-icon>
              <span class="body-heading-small white--text">{{ points }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {
    name: "NameInfoBanner",
    props: ["name", "avatar", "points"],
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/NameInfoBanner.vue